/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Mk_Proof_OverlineInputs */

const en_mk_proof_overline = /** @type {(inputs: Mk_Proof_OverlineInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`PROOF OF DONE`)
};

const id_mk_proof_overline = /** @type {(inputs: Mk_Proof_OverlineInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`BUKTI SELESAI`)
};

/**
* | output |
* | --- |
* | "PROOF OF DONE" |
*
* @param {Mk_Proof_OverlineInputs} inputs
* @param {{ locale?: "en" | "id" }} options
* @returns {LocalizedString}
*/
export const mk_proof_overline = /** @type {((inputs?: Mk_Proof_OverlineInputs, options?: { locale?: "en" | "id" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Mk_Proof_OverlineInputs, { locale?: "en" | "id" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "id") return id_mk_proof_overline(inputs)
	return en_mk_proof_overline(inputs)
});